import React, { useState, useEffect } from 'react';
import { Container, Section } from 'components/shared';
import { getFieldValue } from '@sitecore-jss/sitecore-jss-react';

import { ExpansionPanelFeaturesBlock } from 'components/components/organisms';
const ExpansionFeatures = ({ fields, rendering }) => {
  const cta = getFieldValue(fields, 'cta');
  const blocks = getFieldValue(fields, 'blocks');
  const title = getFieldValue(fields, 'title');
  const filteredBlocks = blocks ? blocks.slice(0, 9) : [];
  const openOnLanding = getFieldValue(fields, 'openOnLanding');

  if (filteredBlocks.length < 3 || !title) {
    return null;
  }

  return (
    <Section>
      <Container>
        <ExpansionPanelFeaturesBlock
          cta={cta}
          features={filteredBlocks}
          title={title}
          type='grid'
          openOnLanding={openOnLanding}
        />
      </Container>
    </Section>
  );
};

export default ExpansionFeatures;
